import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { OnboardingSequenceForm } from '@/admin/sitecontent/OnboardingSequenceForm';
import { DetailPage } from '@/admin/ui/Editor';
import { BackLink } from '@/admin/ui/NavLinks';
import { PageTitle } from '@/admin/ui/Page';

export const Route = createFileRoute('/admin/onboardings/new')({
  staticData: { minTier: 'ADMIN' },
  component: NewOnboarding,
});

function NewOnboarding() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <DetailPage>
      <BackLink>
        <Link to="/admin/onboardings/">
          {t('admin.contentNav.backToOnboardings')}
        </Link>
      </BackLink>
      <PageTitle>{t('admin.onboardings.newOnboarding')}</PageTitle>
      <OnboardingSequenceForm
        onSaved={(id) =>
          navigate({
            to: '/admin/onboardings/$onboardingId/',
            params: { onboardingId: String(id) },
          })
        }
        onCancel={() => navigate({ to: '/admin/onboardings/' })}
      />
    </DetailPage>
  );
}
